import preview from './preview'

const importDirectives = Vue => {
  Vue.directive('preview', preview)
}

export default importDirectives



// WEBPACK FOOTER //
// ./src/utils/directives/index.js